



















































import { defineComponent, ref } from '@vue/composition-api';
import Vue from 'vue';
import { AxiosError } from 'axios';

import { duplicateSampleMenu as active } from '../state';
import { snackbar } from '@/components/GlobalSnackbar';
import { useClient } from '@/use';

type Form = Vue & { reset: () => unknown };
export default defineComponent({
  name: 'DuplicateSampleMenu',
  setup() {
    const client = useClient();
    const loading = ref(false);

    // Form values
    const notEmptyRule = (val: unknown) => !!val;
    const form = ref<Form | null>(null);
    const formValid = ref(false);
    const datasetPrefix = ref('');
    const samplesPerDataset = ref<number | null>(null);
    const csvFile = ref<File | null>(null);

    function close() {
      if (form.value === null) {
        throw new Error('Cannot access form ref.');
      }

      form.value.reset();
      active.value = false;
    }

    async function submit() {
      if (!datasetPrefix.value || samplesPerDataset.value === null || csvFile.value === null) {
        throw new Error('Cannot submit request with uninitialized data.');
      }

      // Make request
      try {
        await client.submitDuplicateSamples(datasetPrefix.value, samplesPerDataset.value, csvFile.value);
        close();
      } catch (error) {
        // Print error
        const err = error as AxiosError<{message?: string}>;
        const data = err.response?.data;
        const message = data?.message !== undefined ? data.message : data;
        console.error(message);

        // Dispatch notification
        snackbar.dispatch({
          text: 'An error occured, please check the console.',
          options: {
            color: 'error',
            top: true,
            immediate: true,
          },
        });
      }
    }

    return {
      active,
      loading,
      notEmptyRule,
      form,
      formValid,
      datasetPrefix,
      samplesPerDataset,
      csvFile,

      close,
      submit,
    };
  },
});
